import { useStore } from 'effector-react'
import { $sorting, nextSort } from 'features/cars-list/model'
import { Order, Sorting, SortType } from 'features/cars-list/types'
import React, { FC } from 'react'
import styled from 'styled-components'

type Props = Sorting

export const GenericV2Sort: FC<Props> = ({ text, options }) => {
  const sorting = useStore($sorting)

  const handleSort = (sort: SortType, order?: Order) => {
    nextSort({ sort, order })
  }

  return (
    <SortWrapper>
      <SortContainer>
        <SortLabel>Сортировать по</SortLabel>
        <SortOptions>
          <SortOption
            active={sorting.sort === 'price' && sorting.order === 'asc'}
            onClick={() => handleSort('price', 'asc')}
          >
            <SortText>возрастанию цены</SortText>
          </SortOption>
          <Slash>/</Slash>
          <SortOption
            active={sorting.sort === 'price' && sorting.order === 'desc'}
            onClick={() => handleSort('price', 'desc')}
          >
            <SortText>убыванию цены</SortText>
          </SortOption>
        </SortOptions>
      </SortContainer>
    </SortWrapper>
  )
}

// Объявление всех необходимых стилей

const SortText = styled.span`
  color: #d9d9d9;
  font-family: Manrope;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
`

const SortWrapper = styled.div`
  display: flex;
  justify-content: end;
`

const SortContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`

const SortLabel = styled.span`
  color: var(--primary-grey-light, #828282);
  font-family: Manrope;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
`

const SortOptions = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
`

const SortOption = styled.div<{ active: boolean }>`
  display: flex;
  flex-direction: column;
  align-items: center;
  cursor: pointer;
  position: relative;

  &:hover::after {
    content: '';
    width: 100%;
    height: 1px;
    background: #d9d9d9;
    position: absolute;
    bottom: -2px;
    left: 0;
  }

  ${({ active }) =>
    active &&
    `
    &::after {
      content: '';
      width: 100%;
      height: 1px;
      background: #d9d9d9;
      position: absolute;
      bottom: -2px;
      left: 0;
    }
  `}
`

const Slash = styled.span`
  color: var(--primary-white, #d9d9d9);
  font-family: Manrope;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
`
